module.exports = __webpack_public_path__ + "img/AL8000-1.970bb732.jpg";